module.exports = __webpack_public_path__ + "static/img/six_star.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/six_star.png
// module id = 78UE
// module chunks = 0